import AppHeader from "../../shared/components/AppHeader";
import React, { useEffect, useState } from "react";
import "./tutor.scss";
import TableComponent from "../../shared/components/TableComponent";
import CardMenu from "../../shared/components/CourseComponents/CardMenu";
import avatarPlaceholder from "../../assets/placeholder/avatar_placeholder.png";
import TutorForm from "./TutorForm";
import DeleteAlert from "../../shared/components/DeleteAlert";
import { generatePath, withRouter } from "react-router-dom";
import * as appRoutes from "../../routes/routeConstants/appRoutes";
import { InstituteTutorModel } from "../../models/InstituteModel/tutor.model"; 
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import TutorService from "../../services/TutorService/tutor.service";
import EmptyState from "../../shared/components/EmptyState";
import Filters from "../../shared/components/Filters";
import TreeSelectComponent from "../../shared/components/TreeSelectComponent";
import { treeOptions } from "../Students";
import { Divider } from "antd";

const Tutors = (props: any) => {
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [currentTutor, setCurrentTutor] = useState<any>(null);
  const [tutors, setTutors] = useState<any>([]);
  const [paginationMeta, setPaginationMeta] = useState<any>();
  const [showFilter, setFilterVisibility] = useState(false);
  useEffect(() => {
    fetchTutorsList(1);
  }, []);

  useEffect(() => {
    setCurrentTutor(formVisible && currentTutor ? currentTutor : null);
  }, [formVisible]);

  const fetchTutorsList = (page: number) => {
    let queryParams = `?per_page=15&page=${page}`;
    TutorService.getTutorsList(
      queryParams,
      (tutors: InstituteTutorModel, pagination: PaginationModel) => {
        setTutors(tutors);
        setPaginationMeta(pagination);
      },
      () => {},
      () => {}
    ).then();
  };

  const handleSearch = (value: string) => {};

  const handleDelete = () => {
    TutorService.deleteTutor(
      currentTutor.id,
      () => {
        fetchTutorsList(1);
        setDeleteVisible(false);
      },
      () => {},
      () => {}
    ).then();
  };
  const columns = [
    {
      title: "Tutor ID",
      dataIndex: "tutorId",
      key: "tutorId",
      sorter: (a: any, b: any) => (a.tutorId > b.tutorId ? 1 : -1),
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (name: string, record: any) => (
        <>
          <img
            src={record.displayPictureUrl || avatarPlaceholder}
            alt=""
            className="table-image"
          />{" "}
          {name}
        </>
      ),
      sorter: (a: any, b: any) => (a.name > b.name ? 1 : -1),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text: boolean) => (
        <>
          <span
            className={`status__indicator ${text ? "active" : "inactive"}`}
          />
          {text ? "Active" : "Inactive"}
        </>
      ),
      sorter: (a: any, b: any) => a.isActive - b.isActive,
    },
    {
      title: "",
      dataIndex: "",
      key: "action",
      render: (text: string, record: any) => (
        <div
          onClick={(event) => {
            event.stopPropagation();
            setCurrentTutor(record);
          }}
        >
          <CardMenu
            menuText="Tutor"
            handleEdit={setFormVisible}
            handleDelete={setDeleteVisible}
          />
        </div>
      ),
    },
  ];

  const dataSource = tutors.map((tutor: InstituteTutorModel) => ({
    key: tutor.id,
    tutorId: tutor.id,
    ...tutor
  }));

  return (
    <div className="page-view">
      <AppHeader
        headerText="Tutors"
        handleSearch={handleSearch}
        handleHeaderAction={() => setFormVisible(true)}
        buttonText="Tutor"
        showBreadCrumb={false}
        showFilter={true}
        // handleFilter={() => setFilterVisibility(true)}
      />

      {currentTutor ? (
        <TutorForm
          title="Edit tutor"
          visible={formVisible}
          setVisible={setFormVisible}
          data={currentTutor}
          refreshList={fetchTutorsList}
        />
      ) : (
        <TutorForm
          title="Create new tutor"
          visible={formVisible}
          setVisible={setFormVisible}
          refreshList={fetchTutorsList}
        />
      )}
      <DeleteAlert
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText={"tutor"}
        contentTitle={currentTutor?.fullName}
        logo={currentTutor?.displayPictureUrl || avatarPlaceholder}
        detail={"Tutor"}
        handleDelete={handleDelete}
      />
      {tutors.length !== 0 ? (
        <TableComponent
          dataSource={dataSource}
          columns={columns}
          pagination={paginationMeta}
          fetchList={fetchTutorsList}
          handleRowClick={(e: any, record: any) => {
            props.history.push(
              generatePath(appRoutes.TUTOR_DETAILS, { tutorId: record.id })
            );
          }}
        />
      ) : (
        <EmptyState text={"No tutors found."} />
      )}
      <Filters
        handleApply={() => {}}
        handleReset={() =>  {}}
        expand={showFilter}
        closeHandler={() => setFilterVisibility(false)}
      >
         <TreeSelectComponent
          data={[{ title: "Boards", value: 0, children: treeOptions }]}
        />
        <Divider />
        <TreeSelectComponent
          data={[{ title: "Exams", value: 0, children: treeOptions }]}
        />
      </Filters>
    </div>
  );
};

export default withRouter(Tutors);
